import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from "react-router-dom";
import { Container, Modal, ModalHeader, ModalBody, Button, ModalFooter, Row, Col, Spinner } from 'reactstrap';
import Header from './Layout/Header';
import Menu from './Layout/Menu';
import axios from 'axios';
import useAuth from "../components/Utilities/Hooks/useAuth";
import Footer from './Layout/Footer';
import LoginFooter from '../images/login_footer.png';
import toast, { Toaster } from 'react-hot-toast';

const NonWizardLayout = ({ refreshToken, logout, clearSessionitems }) => {
    const { auth, setAuth } = useAuth(); 
    const idleTimerRef = useRef(null);
    const wasIdleRef = useRef(false);
    useEffect(() => {
        refreshToken();
        const IDLE_MS = 60000;
        const startIdleTimer = () => {
            clearTimeout(idleTimerRef.current);
            idleTimerRef.current = setTimeout(() => {
                wasIdleRef.current = true;
                validateToken();
                startIdleTimer();
            }, IDLE_MS);
        };
        const onUserActivity = () => {
            if (wasIdleRef.current) {
                refreshToken();
                wasIdleRef.current = false;
            }
            startIdleTimer();
        };
        window.addEventListener("mousedown", onUserActivity);
        window.addEventListener("keydown", onUserActivity);
        window.addEventListener("scroll", onUserActivity);
        window.addEventListener("touchstart", onUserActivity);
        startIdleTimer();
        return () => {
            clearTimeout(idleTimerRef.current);
            window.removeEventListener("mousedown", onUserActivity);
            window.removeEventListener("keydown", onUserActivity);
            window.removeEventListener("scroll", onUserActivity);
            window.removeEventListener("touchstart", onUserActivity);
        };
    }, []);
    const validateToken = async () => {
        if (auth != null) {
            let form = {
                Token: localStorage.getItem("accessToken"), Email: auth.email
            }
            const response = await axios.post(
                '/api/Token/Validate/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (!response.data.isTokenValid) {
                localStorage.clear();
                setItemDeletePopup1({ showItemDeletePopup: true });
            }
            else {
                if (response.data.remainingTime <= 10) {
                    //toast.error("You are about to logout in 10 minutes. Kindly save the changes and login again", { duration: 5000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    setItemDeletePopup({ showItemDeletePopup: true });
                }
            }
        }
        else {
            localStorage.clear();
            logout({ returnTo: window.location.origin })
        }
    }
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [itemDeletesaving1, setItemDeleteSaving1] = useState('');
    const [itemDeletePopup1, setItemDeletePopup1] = useState({ showItemDeletePopup: false });
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false });
    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false});
    }
    const handleItemDeletePopupClose1 = () => {
        setItemDeletePopup1({ showItemDeletePopup: false });
        localStorage.clear();
        logout({ returnTo: window.location.origin })
    }
    const handleItemDeletePopupConfirm = async () => {
        if (auth != null) {
            setItemDeleteSaving(true);
            let form = {
                Token: localStorage.getItem("accessToken"),
                UserId: auth.loggedInUserId,
                UserName: auth.username,
                Email: auth.email,
                Role: auth.role
            }
            const response = await axios.post(
                '/api/Token/RefreshToken/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            setItemDeleteSaving(false);
            if (!response.data.isTokenValid) {
                if (auth != null) {
                    let form = {
                        Email: auth.email
                    }
                    const response = await axios.post(
                        '/api/Auth/Logout/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    setAuth({});
                    localStorage.clear();
                    logout({ returnTo: window.location.origin })
                }
                else {
                    localStorage.clear();
                    logout({ returnTo: window.location.origin })
                }
            }
            else {
                setItemDeletePopup({ showItemDeletePopup: false });
            }
        }
    }
    const handleItemDeletePopupConfirm1 = async () => {
        setItemDeletePopup1({ showItemDeletePopup: false });
        if (auth != null) {
            let form = {
                Email: auth.email
            }
            const response = await axios.post(
                '/api/Auth/Logout/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            setAuth({});
            localStorage.clear();
            logout({ returnTo: window.location.origin })
        }
        else {
            localStorage.clear();
            logout({ returnTo: window.location.origin })
        }
    }
    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Header />
            <div style={{ height: "82vh", overflow: "auto", marginBottom: "5vh" }}>
                <Container className="layout-body">
                    <Outlet />
                </Container>
            </div>
            <div className="footerLogin" >
                <div style={{
                    backgroundImage: `url(${LoginFooter})`,
                    backgroundSize: 'unset',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    height: '5vh', marginTop: "-5px", marginRight: "10px"
                }}>
                </div>
            </div>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Session will expire soon!</ModalHeader>
                <ModalBody>
                    Your session  will expire in 10 minutes. Please click OK to refresh and continue, otherwise for security purposes the system will automatically log you out. Please note that any information not saved will need to be re-entered
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={handleItemDeletePopupConfirm} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Processing
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Processing...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={handleItemDeletePopupConfirm} color="primary">
                                Ok
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={itemDeletePopup1.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose1} >Session Expired</ModalHeader>
                <ModalBody>
                    For security purposes the session has ended due to inactivity. Please log in again
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving1 ?
                        <>
                            <Button onClick={handleItemDeletePopupConfirm1} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Processing
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Processing...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={handleItemDeletePopupConfirm1} color="primary">
                                Ok
                            </Button>{' '}
                        </>
                    }
                </ModalFooter>
            </Modal>
        </>
    );
}

export default NonWizardLayout
